// extracted by mini-css-extract-plugin
export default {"tableContainer":"Table_tableContainer__impz4","table":"Table_table__5aser"};